export default "__VITE_ASSET__BwsflzTM__"